import { STOCK_SET_CURRENT, STOCK_SET_LIST } from './actionTypes';

const defaultState = {
  list: null,
  current: null,
};

export function stock(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case STOCK_SET_CURRENT:
      return { ...state, current: payload };

    case STOCK_SET_LIST:
      return { ...state, list: payload };

    default:
      return state;
  }
}
